import PortfolioScenariosPage from "@Quest/PortfolioScenarios/Pages/PortfolioScenariosPage.vue";
import ProjectsPage from "@Quest/PortfolioScenarios/Pages/ProjectsPage.vue";
import ResourceConstraintPage from "@Quest/PortfolioScenarios/Pages/ResourceConstraintPage.vue";
import SchedulingPage from "@Quest/PortfolioScenarios/Pages/SchedulingPage.vue";
import PnlPage from "@Quest/PortfolioScenarios/Pages/PnlPage.vue";
import CriteriaPage from "@Quest/PortfolioScenarios/Pages/CriteriaPage.vue";
import SelectionPage from "@Quest/PortfolioScenarios/Pages/SelectionPage.vue";
import ApprovalPage from "@Quest/PortfolioScenarios/Pages/ApprovalPage.vue";
import ReviewPage from "@Quest/PortfolioScenarios/Pages/ReviewPage.vue";


export const routes = [
    {
        path: "/portfolio/plans/:workspaceId/:tchProjectId",
        component: PortfolioScenariosPage
    },
    {
        path: "/portfolio-plan/projects/:workspaceId/:tchProjectId/:scenarioId",
        component: ProjectsPage
    },
    {
        path: "/portfolio-plan/selection/:workspaceId/:tchProjectId/:scenarioId",
        component: SelectionPage
    },
    {
        path: "/portfolio-plan/schedule/:workspaceId/:tchProjectId/:scenarioId",
        component: SchedulingPage
    },
    {
        path: "/portfolio-plan/approval/:workspaceId/:tchProjectId/:scenarioId",
        component: ApprovalPage
    },
    {
        path: "/portfolio-plan/review/:workspaceId/:tchProjectId/:scenarioId",
        component: ReviewPage
    },
    {
        path: "/portfolio-plan/pnl/:workspaceId/:tchProjectId/:scenarioId",
        component: PnlPage
    },
    {
        path: "/portfolio-plan/criteria/:workspaceId/:tchProjectId/:scenarioId",
        component: CriteriaPage
    },
    {
        path: "/portfolio-plan/resource/:workspaceId/:tchProjectId/:scenarioId/:resourceId",
        component: ResourceConstraintPage
    },
]
